import React from 'react'
import { CircularProgress } from '@material-ui/core'
import styled from '@emotion/styled'
import useChatbotStore from 'src/components/chatbot/stores/chatbotStore'

const LoadingMessageContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.neutral};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  color: ${({ theme }) => theme.palette.text.primary};
  align-self: flex-start;
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  border-radius: 12px;
  width: 60%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`

const ActionMessage = styled.div`
  font-style: italic;
  color: ${({ theme }) => theme.palette.text.secondary};
  display: flex;
  align-items: center;
  gap: 8px;
`

export default function BotLoadingMessage({ isDarkMode }) {
  const { currentActionMessage: actionMessage } = useChatbotStore()

  return (
    <LoadingMessageContainer isDarkMode={isDarkMode}>
      {actionMessage ? (
        <ActionMessage isDarkMode={isDarkMode}>
          <CircularProgress size={12} />
          {actionMessage}
        </ActionMessage>
      ) : (
        // This is for the case of starting a new chat since chatId is not available yet!
        <ActionMessage isDarkMode={isDarkMode}>
          <CircularProgress size={12} />
          Thinking about the user's request...{' '}
        </ActionMessage>
      )}
    </LoadingMessageContainer>
  )
}
